import React, { useState, useEffect, useRef } from 'react';
import {HtmlParse} from 'utils';
import PubSub from "services/PubSub";
import LoginService from "services/Login";
import StorageService from 'services/StorageService';
import TagManagerService from 'services/TagManager';
import ItemStore from './ItemStore';
import ItemAddress from './ItemAddress';
import Loader from "components/Loader";
import { actionsType } from 'config/constants';
import {features } from 'config';
import PropTypes from 'prop-types';
import warning from 'images/icons/warning.svg';
import logoPrime from 'images/icons/logo-jumbo-prime.svg';
import { modalDeliverySelectorTxt, identificationCencoPrime } from 'config/translate/variables';
import DeliverySelectorService from 'services/DeliverySelector';
import ButtonsLogin from 'components/ModalDeliverySelector/DeliverySelector/ButtonsLogin';
import style from './style.scss';//NOSONAR

let actions = [];
let blockedContent = false;

const DeliverySelector = ({settings}) => {
    const [tab, setTab] = useState(false);
    const [stores, setStores] = useState(null);
    const [addresses, setAddresses] = useState(null);
    const [storeSelected, setStoreSelected] = useState(null);
    const [addressSelected, setAddressSelected] = useState(null);
    const [isLoadingAddress, setIsLoadingAddress] = useState(false);
    const [isLoadingStores, setIsLoadingStores] = useState(false);
    const [isLogged, setIsLogged] = useState(false);
    const [notScMessage, setNotScMessage] = useState(false);
    const [notDisponibleMessage, setNotDisponibleMessage] = useState(false);
    const scrollerStore = useRef();
    const scrollerAddress = useRef();
    const dataUser = StorageService.getSecureItem('userData');
    const cencoPrime = dataUser && dataUser.CencoPrime_2020 ? dataUser.CencoPrime_2020 : '';
    const cencoPrimeCat = dataUser && dataUser.CencoPrime_CAT ? dataUser.CencoPrime_CAT : '';

    useEffect(() => {

        actions.push(PubSub.register('address_updated', _getAddress));

        _getAddress();
        _getCurrent();
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];

        }
    }, []);

    useEffect(()=> {
        if(!blockedContent){
            setNotDisponibleMessage(false);
            setNotScMessage(false);
        }else{
            blockedContent = false;
        }

    },[storeSelected, addressSelected, tab]);


    const selectStore = (store, method) => {
        store.method = method;
        setStoreSelected({...store});
    }

    const selectAddress = (add) => {
        setAddressSelected({...add})
    }

    const _getCurrent = () => {
        setIsLoadingStores(true);
        DeliverySelectorService.getCurrent().then(response => {
            setIsLoadingStores(false);
            setTab(response.tab);
            if(response.selectedAddress){
                selectAddress(response.selectedAddress);
            }

            if(response.newStoreSelected){
                setStoreSelected(response.newStoreSelected);
            }

            setStores(response.stores);

        })
    }

    const openAddressModal = () => {
        PubSub.dispatch('address_open', {
            address: null
        });
    }

    const filterStores = (ev) => {

        const value = ev.currentTarget ? ev.currentTarget.value.toUpperCase() : '';

        const ul = document.getElementById("list-stores");
        const li = ul.getElementsByTagName('li');
        for (let i = 0; i < li.length; i++) {
            const title = li[i].getElementsByTagName("span")[0];
            const address = li[i].getElementsByTagName("span")[1];
            const txtValue = (title.textContent +' '+  address.textContent) || (title.innerText +' '+ address.innerText);

            if (txtValue.toUpperCase().indexOf(value) > -1) {
                li[i].style.display = "";
            } else {
                li[i].style.display = "none";
            }
        }
    }

    const _getAddress = () => {
        setIsLoadingAddress(true);

        const token = LoginService.getUserToken();

        if (token) {
            if (!isLoadingAddress) {
                setIsLogged(!!token);
            }
        }

        DeliverySelectorService.getAddress(token).then(response => {
            setIsLoadingAddress(false);
            if(response.listAddress){
                setAddresses(response.listAddress)
            }
            if(response.selectedAddress){
                selectAddress(response.selectedAddress);
            }
        }).catch(() => setIsLoadingAddress(false));
    }

    let initialX = null;
    const startTouch = (e) => {
        initialX = e.touches[0].clientX;
    };

    let diffX = '';
    const moveTouch = (e) => {
        if (initialX === null) return false;

        const currentX = e.touches[0].clientX;
        diffX = initialX - currentX;
    };

    const touchFinish = () => {
        if (diffX) {
            if (diffX > 36) {
                setTab(true)
            }
            if (diffX < -36) {
                setTab(false)
            }
        }
    }

    const close = (callback = false) =>  {
        if(callback && settings && settings.successCallback) settings.successCallback();

        setTimeout(() => PubSub.dispatch(actionsType.MODAL.DELIVERY_SELECTOR_CLOSE),0);
    }

    const submit = () => {
        if(!tab) {
            setIsLoadingAddress(true);
        } else {
            setIsLoadingStores(true);
        }

        DeliverySelectorService.submit(tab, storeSelected, addressSelected, scrollerAddress, scrollerStore, stores).then(response => {

            setIsLoadingAddress(false);
            setIsLoadingStores(false);
            setNotScMessage(response.notScMessage && !response.notDisponibleMessage);
            setNotDisponibleMessage(response.notDisponibleMessage);

            if(!response.error){
                if(response.close) {
                    close();
                } else {
                    if(response.notDisponibleMessage) {
                        setNotDisponibleMessage(true);
                    }
                    _blockedContent();
                }
            }
        })
    }

    const _blockedContent = () => {
        blockedContent = true;
        let tagManager = {
            action: "Dirección sin opciones de despacho disponibles",
            category: "Error"
        };

        if (tab) {
            setStores([...DeliverySelectorService.blockedStore(stores, storeSelected)]);
            setStoreSelected(null);
            tagManager.tag = storeSelected.value;

        } else {
            setAddresses(DeliverySelectorService.blockedAddress(addresses, addressSelected));
            setAddressSelected(null);
            tagManager.tag = addressSelected.value.street + ' ' + addressSelected.value.number + ' ' + addressSelected.value.neighborhood;
        }
        
        TagManagerService.interaction(tagManager.action, tagManager.tag, tagManager.category);
    }
    const disabledButton = (tab && (!(storeSelected && storeSelected.method) || isLoadingStores)) || (!tab && (!(addressSelected && addressSelected.value) || isLoadingAddress));

    let primeInformation = '';

    if(features.primeService) {
        if (cencoPrime){
            primeInformation = identificationCencoPrime.cencoPrime;
        }else if(cencoPrimeCat){
            primeInformation = identificationCencoPrime.cencoPrimeCat;
        } else{
            primeInformation = identificationCencoPrime.notCencoPrime;
        }
    }

    return (
        <div className="delivery-selector-content new-modal-container">
            <div className="new-modal-scroll">
                <div className="delivery-selector-title-wrap"><span className="delivery-selector-title">{modalDeliverySelectorTxt.title}</span></div>
                <div className="delivery-selector-container">
                    <div className="delivery-selector-tabs titles">
                        <div
                            className={'delivery-type-tab-title' + (!tab ? ' active' : '')}
                            onClick={() => setTab(false)}
                            onTouchStart={startTouch}
                            onTouchMove={moveTouch}
                            onTouchEnd={touchFinish}>
                            Despacho
                        </div>
                        <div
                            className={'delivery-type-tab-title' + (tab ? ' active' : '')}
                            onClick={() => setTab(true)}
                            onTouchStart={startTouch}
                            onTouchMove={moveTouch}
                            onTouchEnd={touchFinish}>
                            Retiro
                        </div>
                    </div>
                    <div className={'delivery-selector-tabs' + (isLoadingAddress || isLoadingStores ? ' not-scrolling' : '')}>
                        <div
                            ref={scrollerAddress}
                            className={'delivery-type-tab-content delivery' + (!tab ? ' active' : '')}
                            onTouchStart={startTouch}
                            onTouchMove={moveTouch}
                            onTouchEnd={touchFinish}>
                            <ul id="list-address">
                                {isLoadingAddress && (
                                    <span className="loader-list-wrap">
                                        <Loader />
                                    </span>
                                )}
                                {addresses &&
                                    addresses.map((address, i) => {
                                        return (
                                            <ItemAddress
                                                address={address}
                                                addressSelected={addressSelected}
                                                customOnClick={selectAddress}
                                                key={i}
                                            />
                                        )
                                    })}
                            </ul>

                            {(!addresses || !addresses.length) && !isLoadingAddress && (
                                <div className="delivery-selector-msg-wrap">
                                    {(!addresses || !addresses.length) && !isLoadingAddress && (
                                        <span className="delivery-selector-not-addresses">
                                            Aún no tienes direcciones guardadas{!isLogged && ', '}
                                            {!isLogged && (
                                                <span className="delivery-selector-create-address">
                                                    <a className="new-link" onClick={openAddressModal}>crea una dirección</a> o ingresa a tu cuenta
                                                </span>
                                            )}
                                        </span>
                                    )}
                                    {!isLogged && (!addresses || !addresses.length) && !isLoadingAddress && <ButtonsLogin close={close} />}
                                    {(!addresses || !addresses.length) && !isLoadingAddress && isLogged && (
                                        <button className={'new-link flat-btn delivery-selector-address-add-btn'} onClick={openAddressModal}>
                                            Agregar dirección
                                        </button>
                                    )}
                                </div>
                            )}

                            {addresses && !!addresses.length && (
                                <button className={'new-link flat-btn delivery-selector-address-add-btn'} onClick={openAddressModal}>
                                    Agregar dirección
                                </button>
                            )}
                        </div>
                        {/* STORES */}
                        <div
                            ref={scrollerStore}
                            className={'delivery-type-tab-content withdraw' + (tab ? ' active' : '')}
                            onTouchStart={startTouch}
                            onTouchMove={moveTouch}
                            onTouchEnd={touchFinish}>
                            <input
                                type="text"
                                className="filter-store-input"
                                placeholder="¿Qué local buscas?"
                                onChange={(val) => filterStores(val)}
                            />
                            <ul id="list-stores">
                                {isLoadingStores && (
                                    <span className="loader-list-wrap">
                                        <Loader />
                                    </span>
                                )}
                                {stores &&
                                    stores.map((store, i) => {
                                        return <ItemStore store={store} storeSelected={storeSelected} customOnClick={selectStore} key={i} />
                                    })}
                            </ul>
                            <div>
                                {(!stores || !stores.length) && !isLoadingStores && (
                                    <div className="wrap-warning-icon">{HtmlParse(warning)}</div>
                                )}
                                {(!stores || !stores.length) && !isLoadingStores && (
                                    <span className="delivery-selector-not-addresses">Temporalmente sin cobertura</span>
                                )}
                            </div>
                        </div>
                        {/* END STORES */}
                    </div>
                </div>
            </div>

            <div className={'modal-actions'}>
                {notDisponibleMessage && !tab && (
                    <div className="delivery-selector-error-msg">
                        {modalDeliverySelectorTxt.noWindows}
                        <br />
                        {modalDeliverySelectorTxt.tryLater}
                    </div>
                )}
                {notDisponibleMessage && tab && (
                    <div className="delivery-selector-error-msg">{modalDeliverySelectorTxt.storeUnavailable}</div>
                )}
                {notScMessage && !tab && <div className="delivery-selector-error-msg">{modalDeliverySelectorTxt.noCoverage}</div>}
                {features.primeService && (
                    <div className="cenco-prime-container">
                        <i className="logo-prime">{HtmlParse(logoPrime)}</i>
                        <span className="cenco-prime-information">{HtmlParse(primeInformation)}</span>
                    </div>
                )}
                <span className="btns-actions-delivery">
                    <button className="secundary-btn delivery-selector-btn" onClick={close}>
                        Cancelar
                    </button>
                    <button className="primary-btn delivery-selector-btn" disabled={disabledButton} onClick={submit}>
                        {modalDeliverySelectorTxt.btnSubmit}
                    </button>
                </span>
            </div>
        </div>
    )
}

DeliverySelector.propTypes = {
    settings: PropTypes.object
};

export default DeliverySelector;
